<script setup lang="ts">
defineProps<{
  tooltip: string;
}>();
const { t } = useI18n();
</script>
<template>
  <div
    class="border border-gray-400 rounded py-0.5 px-2 flex items-center w-auto max-w-max"
    :title="tooltip"
  >
    <div class="rounded-full w-2.5 h-2.5 bg-warning-700 mr-2"></div>
    <span class="text-xs text-gray-600 font-medium">{{
      t("license.gauge.device.warning.message")
    }}</span>
  </div>
</template>
